/**
 * Libs
 * */
import styled from 'styled-components';

/**
 * Components
 * */
import { Spacing } from 'src/ui/common/atoms/spacing';

export const StyledAboutUniverse = styled(Spacing)`
    border-bottom: 1px solid ${({ theme }) => theme.colors.gs400};

    img {
        width: 100%;
        border-radius: 4px;
        object-fit: cover;
    }

    p:not(:last-child) {
        margin: 0 0 20px;
    }
`;

export const StyledDescription = styled.span`
    a {
        color: ${({ theme }) => theme.colors.pink500};
    }
`;